import { themeConWeb } from '@app/util/modernThemeConweb'
import { InputError } from '@foodsby/nutrient'
import { Box, Button, Divider, Typography } from '@material-ui/core'
import currency from 'currency.js'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { getIsSubscribed } from '../../api/api'
import { useStateValue } from '../../providers/ProviderCheckout'
import { placeOrderRoute } from '../../routes/routes'
import { formatUrl } from '../../util/formatUtils'
import { pushSnowplow, toOrderProcessSchema } from '../../util/snowplow'
import Action from '../common/Action'
import Submitting from '../common/Submitting'
import CartMenuItemList from './CartMenuItemList'

export const AddMoreItems = ({ dropoffId, locationId }) => (
  <div className="row middle-sm">
    <div className="col-xs-12 center-xs">
      <Link to={formatUrl(placeOrderRoute.path, { dropoffId, locationId })}>
        <Action
          onClick={() => {
            pushSnowplow(toOrderProcessSchema('daily', 'checkout_more_items_add'))
          }}
        >
          + Add More Items
        </Action>
      </Link>
    </div>
  </div>
)

export const CartCheckout = ({ error, isCheckoutProcessing, isInvalid, onCheckout }) => (
  <div className="row middle-sm">
    <div className="col-xs-12 center-xs">
      {isCheckoutProcessing ? (
        <Submitting />
      ) : (
        <Button
          className="cart-checkout"
          color="primary"
          disabled={isInvalid}
          mb={2}
          onClick={onCheckout}
          type="button"
          variant="contained"
        >
          Checkout
        </Button>
      )}
    </div>
    <div className="col-xs-12 center-xs">
      <InputError>{error && error.message}</InputError>
    </div>
  </div>
)

export const CartSubtotalPretax = ({
  couponAmount,
  couponApplied,
  couponCode,
  creditsApplied,
  creditsUsed,
  deliveryFee,
  subtotal,
}) => {
  const [{ subscription }] = useStateValue()

  const [isSubscribed, setIsSubscribed] = useState(null)

  useEffect(() => {
    let isMounted = true
    async function fetchData() {
      const res = await getIsSubscribed()
      if (isMounted) {
        setIsSubscribed(res)
      }
    }
    fetchData()

    return () => {
      isMounted = false
    }
  }, [])

  return (
    <div className="cart-pretax">
      {isSubscribed || subscription.value ? (
        <div className="cart-subtotal cart-delivery-fee">
          <div className="cart-subtotal_title">
            Delivery Fee:{' '}
            <img
              alt=""
              src="https://images.foodsby.com/conweb/subscription-car-new-red.png"
              style={{ margin: '0px 8px 2px 8px', verticalAlign: 'middle' }}
              width="36px"
            />
          </div>
          <div className="cart-subtotal_price">FREE</div>
        </div>
      ) : (
        <div className="cart-subtotal cart-delivery-fee">
          <div className="cart-subtotal_title">Delivery Fee:</div>
          <div className="cart-subtotal_price">
            {currency(deliveryFee, { formatWithSymbol: true }).format()}
          </div>
        </div>
      )}
      {couponApplied ? (
        <div className="cart-subtotal cart-coupons-applied">
          <div className="cart-subtotal_title">{`Coupon: ${couponCode}`}</div>
          <div className="cart-subtotal_price">
            -{currency(couponAmount, { formatWithSymbol: true }).format()}
          </div>
        </div>
      ) : null}
      {creditsApplied ? (
        <div className="cart-subtotal cart-credits-applied">
          <div className="cart-subtotal_title">Credit:</div>
          <div className="cart-subtotal_price">
            -{currency(creditsUsed, { formatWithSymbol: true }).format()}
          </div>
        </div>
      ) : null}
      <div className="cart-subtotal cart-sum">
        <div className="cart-subtotal_title">Subtotal:</div>
        <div className="cart-subtotal_price">
          {currency(subtotal, { formatWithSymbol: true }).format()}
        </div>
      </div>
    </div>
  )
}

export const CartSubtotalPosttax = ({
  gratuityApplied,
  programAmount,
  programApplied,
  programCode,
  storedCurrencyAmount,
  storedCurrencyApplied,
  taxes,
}) => (
  <div className="cart-posttax">
    <div className="cart-subtotal cart-taxes">
      <div className="cart-subtotal_title">Taxes:</div>
      <div className="cart-subtotal_price">
        {currency(taxes, { formatWithSymbol: true }).format()}
      </div>
    </div>
    {programApplied ? (
      <div className="cart-subtotal cart-program">
        <div className="cart-subtotal_title">{programCode}:</div>
        <div className="cart-subtotal_price">
          -{currency(programAmount, { formatWithSymbol: true }).format()}
        </div>
      </div>
    ) : null}
    {storedCurrencyApplied ? (
      <div className="cart-subtotal cart-program">
        <div className="cart-subtotal_title">Gift:</div>
        <div className="cart-subtotal_price">
          -
          {currency(storedCurrencyAmount / 100, {
            formatWithSymbol: true,
          }).format()}
        </div>
      </div>
    ) : null}
    {gratuityApplied > 0 ? (
      <div className="cart-subtotal cart-program">
        <div className="cart-subtotal_title">Gratuity:</div>
        <div className="cart-subtotal_price">
          {currency(gratuityApplied, {
            formatWithSymbol: true,
          }).format()}
        </div>
      </div>
    ) : null}
  </div>
)

export const CartSubtotalDebits = ({ deliveryFee, showTaxes, subtotal, taxes }) => {
  return (
    <div className="cart-debits">
      <div className="cart-subtotal">
        <div className="cart-subtotal_title">Subtotal:</div>
        <div className="cart-subtotal_price">
          {currency(subtotal, { formatWithSymbol: true }).format()}
        </div>
      </div>
      <div className="cart-subtotal cart-delivery-fee">
        <div className="cart-subtotal_title">Delivery Fee:</div>
        <div className="cart-subtotal_price">
          {currency(deliveryFee, { formatWithSymbol: true }).format()}
        </div>
      </div>
      {showTaxes && (
        <div className="cart-subtotal cart-taxes">
          <div className="cart-subtotal_title">Taxes:</div>
          <div className="cart-subtotal_price">
            {currency(taxes, { formatWithSymbol: true }).format()}
          </div>
        </div>
      )}
    </div>
  )
}

CartSubtotalDebits.defaultProps = {
  showTaxes: true,
}

export const CartSubtotalCredits = ({
  couponAmount,
  couponApplied,
  couponCode,
  creditsApplied,
  creditsUsed,
}) => (
  <div className="cart-credits">
    {couponApplied ? (
      <div className="cart-subtotal cart-coupons-applied">
        <div className="cart-subtotal_title">{`Coupon: ${couponCode}`}</div>
        <div className="cart-subtotal_price">
          -{currency(couponAmount, { formatWithSymbol: true }).format()}
        </div>
      </div>
    ) : null}
    {creditsApplied ? (
      <div className="cart-subtotal cart-credits-applied">
        <div className="cart-subtotal_title">Credit:</div>
        <div className="cart-subtotal_price">
          -{currency(creditsUsed, { formatWithSymbol: true }).format()}
        </div>
      </div>
    ) : null}
  </div>
)

export const CartTotal = ({ total, totalTitle = 'Total:' }) => (
  <div className="cart-total cart-sum">
    <div className="cart-subtotal_title">{totalTitle}</div>
    <div className="cart-subtotal_price">
      {currency(total, { formatWithSymbol: true }).format()}
    </div>
  </div>
)

const CartContainer = styled.div`
  padding-top: 16px;
`

export const OrderCart = ({
  cart: { itemSubTotal, orderItems },
  deleteMenuItem,
  dropoffId,
  editMenuItem,
  isEditingPastOrder,
}) => (
  <CartContainer>
    <Typography color="textSecondary" gutterBottom variant="overline">
      Your order
    </Typography>
    <CartMenuItemList
      deleteMenuItem={deleteMenuItem}
      dropoffId={dropoffId}
      editable
      editMenuItem={editMenuItem}
      isEditingPastOrder={isEditingPastOrder}
      menuItems={orderItems}
      showEditLinks
      useFullSubTotal
    />
    <Box marginBottom={2} marginTop={3}>
      <Divider />
    </Box>
    <Box display="flex" justifyContent="space-between">
      <Typography variant="h5">Meal Total</Typography>
      <Typography variant="h5">
        {currency(itemSubTotal, { formatWithSymbol: true }).format()}
      </Typography>
    </Box>
  </CartContainer>
)

// TODO Delete this and use CartContainer when we are updating CheckoutCart
export const Cart = ({ children }) => (
  <div className="cart" style={{ paddingTop: '16px' }}>
    <div className="cart-title">
      <i className="icon icon-cart" style={{ color: themeConWeb.color.greyShade3 }} /> Cart
    </div>
    {children}
  </div>
)

export const CheckoutCart = ({
  cart: { foodsbyFee, orderItems, orderTotal, preTaxSubTotal, taxSubTotal, taxSubtotal }, //again, need to support but subTotal spellings :(
  checkoutCartError,
  checkoutError,
  couponUsage,
  creditUsage,
  deleteMenuItem,
  dropoffId,
  editMenuItem,
  isCheckoutProcessing,
  isEditingPastOrder,
  isInvalid,
  locationId,
  onCheckout,
  programUsage = {},
  storedCurrencyUsage = {},
}) => {
  const noItems =
    checkoutCartError &&
    checkoutCartError.message &&
    checkoutCartError.message.indexOf('No items') > -1

  useEffect(() => {
    if (checkoutError) {
      pushSnowplow(toOrderProcessSchema('daily', 'checkout', checkoutError?.message))
    }
  }, [checkoutError])

  return (
    <Cart>
      {// When the checkout cart can't load we can't do anything
      checkoutCartError ? (
        <>
          <InputError className="cart-error">
            <i className="icon-warning" />{' '}
            {noItems
              ? 'Your cart is empty. Add more items to continue.'
              : 'There was a problem loading your cart.'}
          </InputError>
          {noItems ? (
            <AddMoreItems dropoffId={dropoffId} locationId={locationId} />
          ) : (
            <>
              <p>
                Please refresh the page and try again. If this problem persists,{' '}
                <a href={`/contact`}>contact support</a>.
              </p>
              <small>{checkoutCartError.message}</small>
            </>
          )}
        </>
      ) : (
        <>
          <CartMenuItemList
            deleteMenuItem={deleteMenuItem}
            dropoffId={dropoffId}
            editable
            editMenuItem={editMenuItem}
            isEditingPastOrder={isEditingPastOrder}
            menuItems={orderItems}
            showEditLinks
            useFullSubTotal
          />
          <hr />
          <div className="cart-subtotal-container">
            <CartSubtotalPretax
              couponAmount={couponUsage.couponAmount}
              couponApplied={!couponUsage.isEpp && couponUsage.couponApplied}
              couponCode={couponUsage.couponCode}
              creditsApplied={creditUsage.creditsApplied}
              creditsUsed={creditUsage.creditBalanceUsed}
              deliveryFee={foodsbyFee}
              subtotal={preTaxSubTotal}
            />
            <hr />
            {/* NOTE: the couponUsage portion of this section will need to be removed once Accounts has all EPP's established in prod */}
            <CartSubtotalPosttax
              programAmount={
                (programUsage && programUsage.programAmount) || couponUsage.couponAmount
              }
              programApplied={
                (programUsage && programUsage.programApplied) ||
                (couponUsage.couponApplied && couponUsage.isEpp)
              }
              programCode={(programUsage && programUsage.programName) || couponUsage.couponCode}
              storedCurrencyAmount={storedCurrencyUsage?.storedCurrencyBalanceUsed}
              storedCurrencyApplied={storedCurrencyUsage?.storedCurrencyApplied}
              taxes={taxSubTotal || taxSubtotal}
            />
          </div>
          <CartTotal total={orderTotal} totalTitle={'Total:'} />
          <CartCheckout
            error={checkoutError}
            isCheckoutProcessing={isCheckoutProcessing}
            isInvalid={isInvalid || !orderItems || orderItems.length === 0}
            onCheckout={onCheckout}
          />
          <AddMoreItems dropoffId={dropoffId} locationId={locationId} />
          <Box mt={3}>
            <Typography color="textSecondary" variant="caption">
              This site is protected by reCAPTCHA and the Google{' '}
              <a href="https://policies.google.com/privacy">Privacy Policy</a> and{' '}
              <a href="https://policies.google.com/terms">Terms of Service</a> apply.
            </Typography>
          </Box>
        </>
      )}
    </Cart>
  )
}
